<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-progress-bar
	mode="determinate"
	[value]="percentage"
/>
